import React, { useEffect, useState } from "react";
import styles from "./cart.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import productImage from "../../images/product_1.png"
import {
  getDataFromRoutes, setMetaTags, setPrimaryKeyInProductsList,
  convertCartToOrderProductsList
} from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import Loader from "../../components/loader/loader";
import { useSelector, useDispatch } from "react-redux";
import { ROUTES_CONST, TITLE_CART_CHOICE } from "../../utils/constants";
import { getCart, getUser, getLoading } from "../../services/selectors";
import {
  INCREMENT_PRODUCT, DECREMENT_PRODUCT, SET_ACTIVE_PRODUCT, RESET_ACTIVE_PRODUCT,
  SET_ALL_ACTIVE, RESET_ALL_ACTIVE,
  putSyncCartThunk
} from "../../services/actions/cart_actions";
import { SET_PORTAL_BUTTONS, RESET_PORTAL, SET_PORTAL_CONFIRM } from "../../services/actions/portal_actions";
import { TypeConfirm } from "../../utils/constants";
import { TITLE_CONFIRM, TEXT_REMOVE_PRODUCT, TEXT_REMOVE_ACTIVE_PRODUCTS } from "../../utils/constants";
import { getCookie } from "../../utils/cookie";
import { getProductsAndTransportedThunk } from "../../services/actions/products_actions";

const Cart = () => {

  const [sum, setSum] = useState(0);
  const [totalSum, setTotalSum] = useState(0);
  const [discount, setDiscount] = useState(0);

  const location = useLocation();

  const isLoading = useSelector(getLoading);
  const cart = useSelector(getCart);
  const user = useSelector(getUser);

  const navigate = useNavigate();

  const emptyCart = cart.productsInCart.length === 0 ? true : false;

  const dispatch = useDispatch();

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  useEffect(() => {
    calcPrices(cart.productsInCart);
  }, [cart.productsInCart]);

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => { window.scrollTo({ top: 0, left: 0 }) }, []);

  const disableIncrement = (item) => {
    if (item.product.sell_to_order) {
      if (item.count > (item.product.max_count_order - item.product.multiple_count)) return true;
    } else {
      if (item.count > (item.product.available_count - item.product.multiple_count)) return true;
    }
    return false;
  }

  const incrementProduct = (product) => {
    const thisProductInCart = cart.productsInCart.find(
      productInCart => productInCart.product.id === product.id
    );
    if (thisProductInCart.product.sell_to_order) {
      if (thisProductInCart.count > (product.max_count_order - product.multiple_count)) return;
    } else {
      if (thisProductInCart.count > (product.available_count - product.multiple_count)) return;
    }
    if (user.loggedIn && user.is_active) {
      const newCart = [...cart.productsInCart.map(productInCart => {
        if (
          productInCart.product.id === product.id &&
          productInCart.count <= (product.max_count_order - product.multiple_count)
        ) {
          return { ...productInCart, count: productInCart.count + product.multiple_count };
        }
        return productInCart;
      })];
      dispatch(
        putSyncCartThunk(
          accessToken, refreshToken,
          setPrimaryKeyInProductsList(newCart))
      );
    } else {
      dispatch({ type: INCREMENT_PRODUCT, payload: product.id });
    }
  }

  const decrementProduct = (product) => {
    const thisProductInCart = cart.productsInCart.find(
      productInCart => productInCart.product.id === product.id
    );
    if (thisProductInCart.count < product.min_count_order + product.multiple_count) return;
    if (user.loggedIn && user.is_active) {
      const newCart = [...cart.productsInCart.map(productInCart => {
        if (
          productInCart.product.id === product.id &&
          productInCart.count >= (product.min_count_order + product.multiple_count)) {
          return { ...productInCart, count: productInCart.count - product.multiple_count };
        }
        return productInCart;
      })];
      dispatch(
        putSyncCartThunk(
          accessToken, refreshToken,
          setPrimaryKeyInProductsList(newCart))
      );
    } else {
      dispatch({ type: DECREMENT_PRODUCT, payload: product.id });
    }
  }
  const switchActive = (productObj) => {
    if (user.loggedIn && user.is_active) {
      const newCart = [
        ...cart.productsInCart.map(productInCart => {
          if (productInCart.product.id === productObj.product.id) {
            return { ...productInCart, active: !productInCart.active }
          }
          return productInCart;
        })
      ]
      dispatch(
        putSyncCartThunk(
          accessToken, refreshToken,
          setPrimaryKeyInProductsList(newCart))
      );
    } else {
      if (productObj.active) {
        dispatch({ type: RESET_ACTIVE_PRODUCT, payload: productObj });
      } else {
        dispatch({ type: SET_ACTIVE_PRODUCT, payload: productObj });
      }
    }




  }
  const switchAllActive = () => {
    if (user.loggedIn && user.is_active) {
      let newCart = [];
      if (cart.allActive) {
        newCart = [
          ...cart.productsInCart.map(productInCart => ({ ...productInCart, active: false }))
        ]
      } else {
        newCart = [
          ...cart.productsInCart.map(productInCart => ({ ...productInCart, active: true }))
        ]
      }
      dispatch(
        putSyncCartThunk(
          accessToken, refreshToken,
          setPrimaryKeyInProductsList(newCart))
      );
    } else {
      if (cart.allActive) {
        dispatch({ type: RESET_ALL_ACTIVE });
      } else {
        dispatch({ type: SET_ALL_ACTIVE });
      }
    }
  }

  const calcPrices = (list) => {
    let resultSum = 0;
    let resultDiscount = 0;
    let resultTotalSum = 0;
    if (!Array.isArray(list) || list.length === 0) {
      setSum(resultSum);
      setDiscount(resultDiscount);
      setTotalSum(resultTotalSum);
      return;
    };
    list.forEach(productObj => {
      if (productObj.active) {
        resultSum += productObj.product.price * productObj.count;
        resultTotalSum += (productObj.product.final_price * productObj.count);
      }
    })
    setSum(resultSum);
    setDiscount(resultSum - resultTotalSum);
    setTotalSum(resultTotalSum);
  }

  const removeActiveProducts = () => {
    dispatch({
      type: SET_PORTAL_CONFIRM,
      title: TITLE_CONFIRM,
      text: TEXT_REMOVE_ACTIVE_PRODUCTS,
      typeConfirm: TypeConfirm.RemoveActiveFromCart,
    });
  }

  const removeProduct = (productObj) => {
    dispatch({
      type: SET_PORTAL_CONFIRM,
      payload: productObj,
      title: TITLE_CONFIRM,
      text: TEXT_REMOVE_PRODUCT,
      typeConfirm: TypeConfirm.RemoveProductFromCart,
      productObj
    });
  }

  const buttonsList = [
    {
      name: 'Войти',
      func: () => {
        location.state = { from: location };
        dispatch({ type: RESET_PORTAL });
        navigate('/login', { state: { from: location } });
      },
      text: 'Авторизуйтесь, если Вы зарегистрированы'
    },
    {
      name: 'Регистрация',
      func: () => {
        dispatch({ type: RESET_PORTAL });
        navigate('/register')
      },
      text: 'Регистрация позволяет отслеживать заказы, совершать покупки на юридическое лицо, использовать персональные скидки'
    },
    {
      name: 'Заказ без регистрации',
      func: () => {
        dispatch({ type: RESET_PORTAL });
        navigate('/new_order', { state: { from: location.pathname } });
      },
      text: 'Покупки только для физических лиц, без персональных скидок'
    },
  ]


  // оформление заказа
  const handlePlaceOrder = (e) => {
    e.preventDefault();
    if (user.loggedIn) {
      const convertedList = convertCartToOrderProductsList(cart.productsInCart, user);
      dispatch(
        getProductsAndTransportedThunk(
          accessToken, accessToken, convertedList, user, navigate)
      );
    } else {
      dispatch({
        type: SET_PORTAL_BUTTONS,
        title: TITLE_CART_CHOICE,
        buttons: buttonsList
      });
    }

  }

  return (
    <main className='main'>
      {isLoading && <Loader />}
      <h1 className="title">{title}</h1>
      {emptyCart ? <p className="subtitle gray">Ваша корзина пуста</p> :
        <div className={styles.cartContainer}>
          <section className={styles.cartActions}>
            <button className={styles.buttonSelectAll} onClick={switchAllActive}>
              {cart.allActive ? 'Снять выбор' : 'Выбрать все'}
            </button>
            <button className={`${styles.buttonDeleteSelected}`}
              onClick={() => removeActiveProducts()} disabled={cart.allNoActive}>
              Удалить выбранные
            </button>
          </section>
          <ul className={styles.list}>
            {cart.productsInCart.map(item => {
              return (
                <li key={item.product.id} className={styles.listItem}>
                  <div className={styles.checkImage}>
                    <input type="checkbox"
                      checked={item.active} className="checkbox"
                      onChange={() => switchActive(item)} />
                    <img
                      className={styles.imageProduct}
                      src={item.product.image1 ? item.product.image1 : productImage}
                      alt={item.product.name} />
                  </div>
                  <div className={styles.nameContainer}>
                    <a
                      className={styles.nameProduct} href={item.product.path} target="_blank"
                      rel="noreferrer"
                    >
                      {item.product.name}
                    </a>
                  </div>
                  <div className={styles.priceCountContainer}>
                    <div className={styles.priceMultiMinContainer}>
                      <div className={styles.priceContainer}>
                        {item.product.price === item.product.final_price && item.count === 1 &&
                          <>
                            <p className={styles.sumPriceProduct}>
                              {(item.product.final_price * item.count).toLocaleString()}  &#8381;
                            </p>
                          </>
                        }
                        {item.product.price === item.product.final_price && item.count > 1 &&
                          <>
                            <p className={styles.sumPriceProduct}>
                              {(item.product.final_price * item.count).toLocaleString()}  &#8381;
                            </p>
                            <div className={styles.subPriceContainer}>
                              <p className={`${styles.priceProduct}`}>
                                {item.product.final_price.toLocaleString()}  &#8381;/шт.
                              </p>
                            </div>
                          </>
                        }
                        {item.product.price !== item.product.final_price && item.count === 1 &&
                          <>
                            <p className={styles.sumPriceProduct}>
                              {(item.product.final_price * item.count).toLocaleString()}  &#8381;
                            </p>
                            <div className={styles.subPriceContainer}>
                              <p className={`${styles.priceProduct} ${styles.priceProduct__old}`}>
                                {item.product.price.toLocaleString()}  &#8381;
                              </p>
                            </div>
                          </>
                        }
                        {item.product.price !== item.product.final_price && item.count > 1 &&
                          <>
                            <p className={styles.sumPriceProduct}>
                              {(item.product.final_price * item.count).toLocaleString()}  &#8381;
                            </p>
                            <div className={styles.subPriceContainer}>
                              <p className={`${styles.priceProduct}`}>
                                {item.product.final_price.toLocaleString()}  &#8381;/шт.
                              </p>
                              <p className={`${styles.priceProduct} ${styles.priceProduct__old}`}>
                                {item.product.price.toLocaleString()}  &#8381;/шт.
                              </p>
                            </div>
                          </>
                        }
                      </div>
                      <div className={styles.detailsAvailable}>
                        {item.product.min_count_order > 1 &&
                          <p className={styles.countAvailable}>
                            Минимальный заказ: {item.product.min_count_order}
                          </p>
                        }
                        {item.product.multiple_count > 1 &&
                          <p className={styles.countAvailable}>
                            Кратность заказа: {item.product.multiple_count}
                          </p>
                        }
                      </div>
                    </div>
                    <button
                      className={`${styles.countButton} ${styles.countButton__remove}`}
                      onClick={() => removeProduct(item)}
                    ></button>
                    <div className={styles.infoCountContainer}>
                      <div className={styles.countContainer}>
                        <button
                          className={`${styles.countButton}`}
                          onClick={() => decrementProduct(item.product)}
                          disabled={item.product.multiple_count > (item.count - item.product.min_count_order)}

                        >-</button>
                        <p className={styles.countProduct}>{item.count}</p>
                        <button
                          className={styles.countButton}
                          onClick={() => incrementProduct(item.product)}
                          disabled={disableIncrement(item)}
                        >+</button>
                      </div>
                      {item.count > item.product.available_count &&
                        <div className={styles.detailsAvailable}>
                          <p className={styles.countAvailable}>
                            В наличии: {item.product.available_count}
                          </p>
                          <p className={styles.countAvailable}>
                            Под заказ: {item.count - item.product.available_count}
                          </p>
                        </div>
                      }
                    </div>
                  </div>
                </li>
              )
            }).reverse()
            }
          </ul>
          <section className={styles.totalContainer}>
            <div className={styles.totals}>
              {discount > 0 &&
                <>
                  <p className={styles.totalPrice}>
                    Стоимость: <span className={styles.span}>{sum.toLocaleString()} &#8381;</span>
                  </p>
                  <p className={styles.totalSale}>
                    Скидка: <span className={styles.span}>{discount.toLocaleString()} &#8381;</span>
                  </p>
                </>
              }
              <p className={styles.totalSum}>
                Итого: <span className={styles.span}>{totalSum.toLocaleString()} &#8381;</span>
              </p>
            </div>
            <button className={`button button__medium ${cart.allNoActive ? 'button_disabled' : ''}`}
              disabled={cart.allNoActive}
              onClick={handlePlaceOrder}>
              Перейти к оформлению
            </button>
          </section>
        </div>
      }
    </main >
  );
}

export default Cart;
